/**
 * 실패 이벤트에 남길 error_code. `error.name`은 거의 항상 "Error"라 원인을 구분할 수 없다.
 * 서버가 준 code → HTTP 상태 → 메시지(타임아웃·네트워크) 순으로 고른다.
 */

const QUOTA_CODE_RE = /already_used|quota|usage_limit|limit_exceeded/;
// 서버가 detail 에 안내 문장을 넣으면 그 문장이 code 로 들어온다. 코드 모양만 코드로 쓴다.
const CODE_TOKEN_RE = /^[a-z][a-z0-9_.-]{1,63}$/;

export const isTrackingCodeToken = (value) => typeof value === 'string' && CODE_TOKEN_RE.test(value);

export const getTrackingErrorCode = (error) => {
  if (!error) return 'unknown';
  // DOMException(AbortError 등)의 code 는 숫자(20)라 서버 code 로 오인하지 않는다.
  if (isTrackingCodeToken(error.code)) return error.code;
  const message = String(error.message || '');
  if (message.includes('응답 시간이 초과')) return 'timeout';
  if (/Failed to fetch|NetworkError|Load failed/.test(message)) return 'network';
  if (error.status === 429) return 'rate_limited';
  if (error.status) return `http_${error.status}`;
  if (error.name && error.name !== 'Error') return error.name;
  return 'unknown';
};

export const isQuotaErrorCode = (code) => QUOTA_CODE_RE.test(String(code || ''));
